var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-flex"},[_c('div',{staticClass:"modal-flex-inner"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-size",style:(`width: ${_vm.width}px; height: ${_vm.height}px; overflow: hidden;`)},[_c('iframe',{attrs:{"src":_vm.src}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }